import type {
    WeekdayShortName} from "@@/shared/parse-weekly-schedule";
import {
    isWeekdayShortName
} from "@@/shared/parse-weekly-schedule";
import { getWeekdayShortNameInEnglishFromDate } from "@@/utilities/date-and-time/name-of-day";
import { toZonedTime } from "date-fns-tz";
import { asDate } from "../as-date";
import type { IsoAndUnixTimestamp } from "../iso-and-unix";
import type { WeekAvailability } from "./week-availability";

function isAvailableNow(availability: WeekAvailability | undefined): boolean;
function isAvailableNow(availability: WeekAvailability | undefined): boolean;
function isAvailableNow(availability: WeekAvailability | undefined): boolean {
    return isAvailableAt(availability, new Date());
}

function isAvailableToday(availability: WeekAvailability | undefined): boolean {
    return isAvailableAt(
        availability,
        getWeekdayShortNameInEnglishFromDate(new Date()),
    );
}

function isAvailableAt(
    availability: WeekAvailability | undefined,
    at: Date,
): boolean;
function isAvailableAt(
    availability: WeekAvailability | undefined,
    at: WeekdayShortName,
): boolean;
function isAvailableAt(
    availability: WeekAvailability | undefined,
    at: IsoAndUnixTimestamp,
): boolean;
function isAvailableAt(
    availability: WeekAvailability | undefined,
    at: Date | IsoAndUnixTimestamp | WeekdayShortName,
): boolean {
    if (typeof availability === "undefined") return true;
    if (isWeekdayShortName(at)) {
        // If askings for a weekday, check if there are any
        // timeranges avaialable that day
        return !!availability.week[at as WeekdayShortName]?.length;
    }
    const _at = at instanceof Date ? at : asDate(at);
    const atZoned = toZonedTime(_at, availability.timezone);
    const weekday = getWeekdayShortNameInEnglishFromDate(_at);
    const hour = atZoned.getHours();
    const minute = atZoned.getMinutes();

    const day = availability.week[weekday];
    if (!day) return false;

    return day.some(span => [
        span.start.hour <= hour,
        span.start.minute <= minute,
        span.end.hour >= hour,
        span.end.minute >= minute,
    ]);
}

export { isAvailableAt, isAvailableNow, isAvailableToday };
